import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/pwa/PwaInstallContext";
import { loadPreviewLogger } from "@/pwa/previewLogger";
import { loadPhrases, getCurrentLang } from "@/contexts/LanguageContext";

loadPreviewLogger();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
// Las frases del idioma activo se cargan antes de pintar (español no necesita archivo).
loadPhrases(getCurrentLang()).finally(() => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
));
